/* Mini week-preview met kolom-highlight op geselecteerde dag en accent op gekozen groep. */

export default function ShiftWeekPreview({ weekData, selectedDate, selectedGroupId, selectedMedewerkerId, form, grpMap }) {
  if (!weekData) {
    return (
      <div className="rounded-md border border-neutral-200 bg-neutral-50 p-3 text-xs text-neutral-500"
           data-testid="week-preview-loading">
        Week-preview laden…
      </div>
    );
  }
  const wkNames = ["Zo", "Ma", "Di", "Wo", "Do", "Vr", "Za"];
  return (
    <div className="rounded-md border border-neutral-200 bg-white overflow-x-auto" data-testid="week-preview">
      <div className="px-3 py-2 border-b border-neutral-100 flex items-center justify-between">
        <div className="text-[10px] uppercase tracking-widest text-neutral-500">
          Week-preview · {weekData.week_start}
        </div>
        {selectedGroupId && grpMap[selectedGroupId] && (
          <div className="text-[10px] text-neutral-600">
            focus: <strong>{grpMap[selectedGroupId].name}</strong>
          </div>
        )}
      </div>
      <table className="w-full text-[10px] border-collapse">
        <thead>
          <tr className="border-b border-neutral-100 bg-neutral-50">
            <th className="text-left py-1.5 px-2 font-semibold text-neutral-600 sticky left-0 bg-neutral-50">Scope</th>
            {weekData.days.map(d => {
              const dt = new Date(d + "T00:00:00");
              const isSel = d === selectedDate;
              return (
                <th key={d} className={`text-left py-1.5 px-1.5 font-semibold ${
                  isSel ? "bg-[color:var(--sage)]/15 text-[color:var(--sage)]" : "text-neutral-600"
                }`}>
                  {wkNames[dt.getDay()]}<br />
                  <span className="text-[9px] font-normal opacity-75">{dt.getDate()}/{dt.getMonth() + 1}</span>
                </th>
              );
            })}
          </tr>
        </thead>
        <tbody>
          {weekData.rows.map(row => {
            const isFocus = row.scope_id === selectedGroupId;
            return (
              <tr key={row.scope_id} className={isFocus ? "bg-[color:var(--sage)]/5" : ""}>
                <td className={`py-1 px-2 align-top sticky left-0 ${isFocus ? "bg-[color:var(--sage)]/5" : "bg-white"}`}>
                  <div className={`text-[11px] ${isFocus ? "font-semibold text-[color:var(--sage)]" : "text-neutral-700"}`}>{row.name}</div>
                </td>
                {weekData.days.map(d => {
                  const cells = row.per_day[d] || [];
                  const isSelectedCol = d === selectedDate;
                  const isVirtualCell = isFocus && isSelectedCol && form.medewerker_id && form.start;
                  return (
                    <td key={d} className={`py-1 px-1 align-top min-w-[70px] ${isSelectedCol ? "bg-[color:var(--sage)]/5" : ""}`}>
                      {cells.length === 0 && !isVirtualCell && <span className="text-neutral-300">—</span>}
                      <div className="space-y-0.5">
                        {cells.map(c => (
                          <div key={c.id} className={`px-1 py-0.5 rounded border text-[9px] leading-tight ${
                              c.medewerker_id === selectedMedewerkerId
                                ? "bg-amber-50 border-amber-200 text-amber-800"
                                : c.gediplomeerd
                                  ? "bg-emerald-50 border-emerald-200 text-emerald-800"
                                  : "bg-neutral-50 border-neutral-200 text-neutral-600"
                            }`}>
                            <div className="font-medium truncate">{c.medewerker_naam}</div>
                            <div className="opacity-75">{c.start}–{c.eind}</div>
                          </div>
                        ))}
                        {isVirtualCell && (
                          <div className="px-1 py-0.5 rounded border-2 border-dashed border-[color:var(--sage)] bg-[color:var(--sage)]/10 text-[color:var(--sage)] text-[9px] leading-tight"
                               data-testid="week-preview-virtual">
                            <div className="font-medium">+ Nieuw</div>
                            <div className="opacity-75">{form.start}–{form.eind}</div>
                          </div>
                        )}
                      </div>
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
      <div className="px-3 py-1.5 border-t border-neutral-100 text-[9px] text-neutral-500">
        groen = diploma-PM · geel = zelfde medewerker eerder deze week · dashed = nieuwe shift
      </div>
    </div>
  );
}
